// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE

import * as Css from "bs-css/src/Css.js";
import * as $$Array from "bs-platform/lib/es6/array.js";
import * as Curry from "bs-platform/lib/es6/curry.js";
import * as $$Image from "./Image.bs.js";
import * as Theme from "../../../Theme.bs.js";
import * as React from "react";
import * as Helpers from "../../../Helpers.bs.js";
import * as WithCss from "../../../bindings/bs-emotion-core/src/WithCss.bs.js";

var grid_000 = Css.display(/* grid */-999565626);

var grid_001 = /* :: */[
  Css.width(Css.pct(100)),
  /* :: */[
    Css.unsafe("gridTemplateColumns", "repeat(auto-fill, 200px)"),
    /* :: */[
      Css.gridAutoFlow(/* rowDense */-15525083),
      /* :: */[
        Css.gridGap(Css.rem(1)),
        /* :: */[
          Css.justifyContent(/* center */98248149),
          /* :: */[
            Css.media(Theme.$$break(/* simpleGallery */588017280), /* :: */[
                  Css.important(Css.unsafe("gridTemplateColumns", "repeat(auto-fill, 100%)")),
                  /* [] */0
                ]),
            /* [] */0
          ]
        ]
      ]
    ]
  ]
];

var grid = /* :: */[
  grid_000,
  grid_001
];

var S = {
  grid: grid
};

function PhotoGrid(Props) {
  var photos = Props.photos;
  var i = {
    contents: 0
  };
  var next_key = function (param) {
    i.contents = i.contents + 1 | 0;
    return i.contents;
  };
  var match = React.useState((function () {
          return 0;
        }));
  var set_active = match[1];
  var active = match[0];
  return React.createElement(React.Fragment, {
              children: React.createElement(WithCss.make, {
                    children: (function (css) {
                        return React.createElement("div", {
                                    className: Curry._2(css, undefined, /* :: */[
                                          grid,
                                          /* [] */0
                                        ])
                                  }, Helpers.array($$Array.map((function (photo) {
                                              var key = next_key(/* () */0);
                                              var nphoto = photo.node;
                                              var active$1 = key === active;
                                              var onClick = function (param) {
                                                var key$1 = key;
                                                return Curry._1(set_active, (function (a) {
                                                              if (a === key$1) {
                                                                return 0;
                                                              } else {
                                                                return key$1;
                                                              }
                                                            }));
                                              };
                                              return React.createElement($$Image.make, {
                                                          nphoto: nphoto,
                                                          active: active$1,
                                                          onClick: onClick,
                                                          key: String(key)
                                                        });
                                            }), photos)));
                      })
                  })
            });
}

var make = PhotoGrid;

export {
  S ,
  make ,
  
}
/* grid Not a pure module */
